// material-ui
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";

// project-imports
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from "config";
import { V2 } from "layout/Dashboard/Drawer/drawerV2Tokens";

/** Admin rail: solid brand accent + white ink (distinct from client white drawer) */
export const ADMIN_DRAWER = {
  bg: V2.accent,
  ink: "#ffffff",
  muted: "rgba(255, 255, 255, 0.78)",
  soft: "rgba(255, 255, 255, 0.12)",
  softHover: "rgba(255, 255, 255, 0.18)",
  line: "rgba(255, 255, 255, 0.16)",
};

const paperBase = {
  backgroundColor: `${ADMIN_DRAWER.bg} !important`,
  backgroundImage: "none !important",
  borderRight: "none",
  boxShadow: "none",
  fontFamily: V2.fontBody,
  color: ADMIN_DRAWER.ink,
  top: 0,
};

const openedMixin = (theme) => ({
  ...paperBase,
  width: DRAWER_WIDTH,
  transition: theme.transitions.create(["width", "top"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  ...paperBase,
  overflow: "hidden",
  width: MINI_DRAWER_WIDTH,
  transition: theme.transitions.create(["width", "top"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
});

// ==============================|| ADMIN DRAWER — brand accent rail ||============================== //

const MiniDrawerStyled = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  fontFamily: V2.fontBody,
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default MiniDrawerStyled;
